export default __webpack_public_path__ + "static/media/P10017.dd231cb4.png";